module.exports = __webpack_public_path__ + "static/media/TestTypeOneActive.1f8a6bda.svg";